// extracted by mini-css-extract-plugin
export default {"events":"events_events__nyUL9","imageOverlay":"events_imageOverlay__ydBFB"};